"use client";

import { usePathname } from "next/navigation";
import type { ReactNode } from "react";

export function HideOnStudio({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  // Studio and the /admin Puck editor are full-screen admin surfaces — the
  // public Header/Footer must not render over them.
  if (pathname.startsWith("/studio") || pathname.startsWith("/admin")) return null;
  return <>{children}</>;
}
